import { ViewOption } from "types/viewOptions";
import AdListSorter from "./AdListSorter";
import AdListViewSelector from "./AdListViewSelector";
import { SortingOptions } from "types/sortingOptions";
import { AdListing } from "types/adListing";

interface AdListHeaderProps {
    sortedIlanlar: AdListing[];
    itemsPerPage: number;
    currentPage: number;
    totalPages: number;
    sortOption: SortingOptions;
    viewType: ViewOption;
    handleSortChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
    handleViewChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
    /** Optional content at the start (e.g. mobile filter button) */
    leftAddon?: React.ReactNode;
}

export default function AdListHeader({ 
    sortedIlanlar,
    itemsPerPage, 
    currentPage, 
    totalPages,
    sortOption, 
    viewType, 
    handleSortChange, 
    handleViewChange,
    leftAddon }: AdListHeaderProps) {
    return (
        <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-2">
            <div className="d-flex align-items-center flex-wrap gap-2">
                {leftAddon}
                <div className="text-muted">
                <strong>{sortedIlanlar.length}</strong> ilan bulundu
                {sortedIlanlar.length > itemsPerPage && (
                    <span className="ms-2">
                        (Sayfa <strong>{currentPage}</strong> / {totalPages})
                    </span>
                )}
                </div>
            </div>
            <div className="d-flex align-items-center gap-2">
                <AdListViewSelector viewType={viewType} handleViewChange={handleViewChange} />
                <AdListSorter sortOption={sortOption} handleSortChange={handleSortChange} />
            </div>
        </div>
    )
}